export default __webpack_public_path__ + "static/banner-mobile-vms-new-561dd1f1cc424bd952d798e1fe69491a.png";